module.exports = lib_ui__dom_scroll_into_view;